export enum EAgilityCustomType {
    Sequence,
    React
}
